var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaneReturn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.257,
    height: 9.73,
    viewBox: "0 0 19.257 9.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Page_1_Copy_2",
    "data-name": "Page 1 Copy 2",
    d: "M.233,4.212,1.549,3.6a.4.4,0,0,1,.382.022L4.512,5.209a.4.4,0,0,0,.394.016L12.9,1.17l.028-.016A8.258,8.258,0,0,1,17.561.021s1.884-.2,1.682,1.145c-.195,1.294-4.372,3.082-5.651,3.457a.394.394,0,0,0-.222.17L10.761,8.92a.4.4,0,0,1-.193.16L8.987,9.7a.4.4,0,0,1-.551-.351L8.3,7.165a.4.4,0,0,0-.547-.352A21.079,21.079,0,0,1,1.069,8.284c-.29,0,.324-.73.692-1.14A.4.4,0,0,0,1.754,6.6L.11,4.855a.4.4,0,0,1,.123-.643Z",
    fill: "#05ce78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneReturn);
export default __webpack_public_path__ + "static/media/plane-return.f19837936c82d0aeed9a73ab6b624b23.svg";
export { ForwardRef as ReactComponent };